import {
  ArrowUp,
  FileText,
  Folder,
  HardDrive,
  MoreHorizontal,
  Paperclip,
  Plus,
  Search,
  Settings,
  Square,
  Trash2,
  Wrench,
} from 'lucide-react';

export const iconMap = {
  add: Plus,
  plus: Plus,
  attach_file: Paperclip,
  hardDrive2: HardDrive,
  settings: Settings,
  article: FileText,
  description: FileText,
  search: Search,
  folder: Folder,
  download: ArrowUp,
  delete2: Trash2,
  dotsMenu2: MoreHorizontal,
  stop: Square,
  arrowUp: ArrowUp,
  tools: Wrench,
};

export const resolveIcon = (name) => iconMap[name] ?? null;
